export const pathwaySteps = [
  {
    verb: 'Identify',
    title: 'Define the Electrical Fault Scenario',
    body: 'Organize the reported problem, equipment behavior, operating conditions, and available service history. Use a structured intake checklist to establish what is known, what remains uncertain, and which observations require verification.',
    output: 'A completed electrical fault intake record.',
  },
  {
    verb: 'Map',
    title: 'Connect the Symptoms to the Electrical Circuit',
    body: 'Use the available equipment documentation to identify relevant power, control, and protection circuits. Organize the relationships between components and determine which portions of the system require further investigation.',
    output: 'A circuit investigation map.',
  },
  {
    verb: 'Verify',
    title: 'Establish the Appropriate Verification Sequence',
    body: 'Determine which checks are relevant, which safety prerequisites apply, and which measurements may be performed by an appropriately qualified professional under approved procedures. Use decision checkpoints to distinguish confirmed findings from assumptions.',
    output: 'A documented verification plan.',
  },
  {
    verb: 'Isolate',
    title: 'Narrow the Investigation Using Decision Trees',
    body: 'Compare documented observations with manufacturer specifications and applicable diagnostic procedures. Organize possible fault categories and identify what additional evidence is required before reaching a conclusion.',
    output: 'A structured fault-isolation worksheet.',
  },
  {
    verb: 'Document',
    title: 'Turn Findings Into a Professional Troubleshooting Report',
    body: 'Record observations, authorized test results, unresolved questions, and recommended next actions. Create a clear record that can support service continuity and professional communication.',
    output: 'A completed electrical troubleshooting report.',
  },
];

export const scenarioSteps = [
  {
    when: 'First',
    title: 'Identify the problem',
    body: 'You document the reported symptoms, available service history, and observed equipment behavior. You establish the known operating conditions and identify any immediate safety concerns.',
  },
  {
    when: 'Next',
    title: 'Map the relevant circuits',
    body: 'Using the correct manufacturer documentation, you organize the power and control circuits associated with the reported complaint, and identify the components and relationships relevant to the investigation.',
  },
  {
    when: 'Then',
    title: 'Plan appropriate verification',
    body: 'You document the applicable safety prerequisites, professional authorization requirements, manufacturer instructions, and verification objectives. Any electrical work is performed only by qualified personnel under approved procedures.',
  },
  {
    when: 'Next',
    title: 'Organize the findings',
    body: 'You compare authorized observations and recorded measurements with relevant specifications, and use the decision trees to distinguish supported findings from unresolved fault possibilities.',
  },
  {
    when: 'Finally',
    title: 'Complete the report',
    body: 'You document the investigation, conclusions supported by available evidence, and recommended next steps.',
  },
];

export const scenarioRecord = [
  'Initial Fault Assessment',
  'Circuit Investigation Map',
  'Verification Plan & Findings',
  'Fault Isolation Summary',
  'Final Service Documentation',
];

export const audiences = [
  {
    role: 'HVAC Service Technicians',
    body: 'Organize electrical troubleshooting activities using structured checklists and decision maps.',
  },
  {
    role: 'HVAC Maintenance Professionals',
    body: 'Create more consistent documentation during equipment investigations and maintenance assessments.',
  },
  {
    role: 'HVAC Diagnostic Technicians',
    body: 'Connect electrical circuit observations with structured fault-isolation records.',
  },
  {
    role: 'HVAC Service Team Leaders',
    body: 'Use standardized worksheets to support service documentation and technician handoffs.',
  },
  {
    role: 'Qualified HVAC Electrical Professionals',
    body: 'Integrate practical workflow tools into existing manufacturer-approved diagnostic and safety procedures.',
  },
];

export const finalChecks = [
  'Initial electrical fault assessment',
  'Wiring diagram investigation',
  'Control circuit evaluation',
  'Appropriate verification planning',
  'Fault isolation documentation',
  'Professional service reporting',
];
